module.exports = __webpack_public_path__ + "assets/img/f797-tw.svg";